/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const User = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M10 10c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm2.8 1h-.5c-.7.3-1.5.5-2.3.5s-1.6-.2-2.3-.5h-.5C4.9 11 3 12.9 3 15.2v1.3c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-1.3c0-2.3-1.9-4.2-4.2-4.2z" />
  </svg>
);

export default extendIcon(User);
